/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFloatLeft = createReactComponent("outline", "float-left", "IconFloatLeft", [["path", { "d": "M4 5m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M14 7l6 0", "key": "svg-1" }], ["path", { "d": "M14 11l6 0", "key": "svg-2" }], ["path", { "d": "M4 15l16 0", "key": "svg-3" }], ["path", { "d": "M4 19l16 0", "key": "svg-4" }]]);

export { IconFloatLeft as default };
//# sourceMappingURL=IconFloatLeft.mjs.map
